import { DatePipe as AngularDatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commonDate'
})
export class DatePipe implements PipeTransform {
  get language() {
    // tslint:disable-next-line: no-any
    const nav = navigator as any;
    if (nav) {
      if (nav.language) {
        return nav.language;
      }
      if (nav.browserLanguage) {
        return nav.browserLanguage;
      }
      if (nav.systemLanguage) {
        return nav.systemLanguage;
      }
      if (nav.userLanguage) {
        return nav.userLanguage;
      }
    }
    return 'en-US';
  }
  // tslint:disable-next-line: no-any
  transform(value: any, args?: any): any {
    if (Object.prototype.toString.call(value) === '[object Date]') {
      if (args === 'withTime') {
        return (
          new AngularDatePipe(this.language).transform(value, 'MM/dd/yyyy') +
          ' at ' +
          new AngularDatePipe(this.language).transform(value, 'H:mm')
        );
      } else if (args === 'with24Time') {
        return (
          new AngularDatePipe(this.language).transform(value, 'MM/dd/yyyy') +
          ' - ' +
          new AngularDatePipe(this.language).transform(value, 'HH:mm')
        );
      } else {
        return new AngularDatePipe(this.language).transform(value, 'MM/dd/yyyy');
      }
    }
    return value;
  }
}
